import axios, { AxiosRequestConfig } from "axios";
import { useSelector } from "react-redux";

export default function useAuth() {
  const { user } = useSelector((state) => state.user);
  const userId = user?.userId || null;

  const config = {
    baseURL: `${process.env.REACT_APP_API_URL}`,
    headers: {
      Authorization: `Bearer ${user?.token}`,
    },
  };

  const request = axios.create(config);

  // Return the Axios instance and user ID.
  return {
    request,
    userId,
  };
}
